import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';
import { GlobalWalletDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

const useFetchPersonalWallet = () => {
  const assetId = useCurrentAssetId();

  return useQuery<GlobalWalletDto, AxiosError<ApiError>>({
    queryKey: ['fetch-personal-wallet', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await expensesApi.expensesControllerGetWallet(assetId)).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchPersonalWallet;
